import React, { useState } from "react";
import Header from "../HomeHeader/Header";
import "./PlayList.css";
import { Splitter, SplitterPanel } from "primereact/splitter";
import LookupviewTree from "../../HomeScreenDetail/LookupviewTree";
import PlaylistLibraryGrid from "../../HomeScreenDetail/PlaylistLibraryGrid";
import PlaylistScheduleHeader from "../../HomeScreenDetail/PlaylistScheduleHeader";
import PlaylistScheduleList from "../../HomeScreenDetail/PlaylistScheduleList";
export default function PlayList() {
  const [newtreeid, SettreeNewid] = useState("");
  const [SchHdrname, SetSchHdrname] = useState("");
  const [schnewid, SetschNewid] = useState("");
  const [DragData, setDragData] = useState([]);
  const [SchdrID, setSchdrID] = useState("");
  const [UpdatedDuration, setUpdatedDuration] = useState("");

  function ontreeselection(value) {
    if (value !== undefined) SettreeNewid(value);
  }
  function onclicheck(value) {
    if (value !== undefined) SetschNewid(value.ScheduleHdrId);
    if (value !== undefined) SetSchHdrname(value.Schedulename);
    setSchdrID(value.ScheduleHdrId);
  }
  function ondragstartvalue(value) {
    setDragData(value);
  }
  function DurationupdateEvents(value) {
    if (value !== undefined) setUpdatedDuration(value);
  }
  return (
    <div>
      <Header />
      <Splitter>
        <SplitterPanel
          size={30}
          minSize={30}
          className="flex align-items-center justify-content-center"
        >
          <PlaylistScheduleHeader
            selectednewid={"1"}
            HideDragIcon={"HideDragIcon"}
            onclickcheck={onclicheck}
            UpdatedDurationParam={UpdatedDuration}
          />
        </SplitterPanel>
        <SplitterPanel
          size={30}
          minSize={20}
          className="flex align-items-center justify-content-center"
        >
          <PlaylistScheduleList
            SchHdrname={SchHdrname}
            schnewid={schnewid}
            DragData={DragData}
            SchdrID={SchdrID}
            DurationUpdateCheck="DurationUpdateCheck"
            DurationupdateEvent={DurationupdateEvents}
          />
        </SplitterPanel>
        <SplitterPanel
          size={40}
          minSize={50}
          className="flex align-items-center justify-content-center"
        >
          <LookupviewTree ontreeselection={ontreeselection} />
          <br />
          <br />

          <PlaylistLibraryGrid
            selectednewid={newtreeid}
            onDragStartValue={ondragstartvalue}
          />
        </SplitterPanel>
      </Splitter>
    </div>
  );
}
